export default "__VITE_ASSET__TdekuZVI__"